var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//region imports

import { tstToDate, dateToTst } from '../../../utils/helpers';
import { GLOBAL_TYPES } from '../../../device/types/global.types';
import { compareAlerts, compareAlertsDesc, compareGroupedItemByTitle, processItems } from './alerts.helper';
import { ALERTS_PER_DIRECTION } from './alerts.constant';

//endregion


//region add to storage

/*
 * add new alerts from db to storage (cache)
 * oldStorageData - data from storage (alerts, alertsImport)
 * newStorageData - items (alerts) + date (on which date get this alerts)
 * */
export const addToStorage = (storageData, items, date, showImportant = false) => {
    if (!items || !items.length) {
        return storageData;
    }

    const key = showImportant ? GLOBAL_TYPES.ALERTS_IMPORTANT : GLOBAL_TYPES.ALERTS;

    const data = storageData[key];
    if (!data) {
        throw 'ERROR during parse alerts data to storage';
    }

    const dateRaw = dateToTst(date);
    // can compare because there are should not be a lot of items from 1 request
    items.sort(compareAlerts);
    const newInterval = {
        minDate: _getMinDate(items, +dateRaw),
        maxDate: _getMaxDate(items, +dateRaw),
        items
    };

    // can compare because there are should not be a lot of different intervals
    let intervals = _addInterval(0, data.intervals.length - 1, data.intervals, newInterval);

    // TODO all this temo - because of not good alg
    // clear duplicates because now BE when select 1.01.17 returns alerts for 14.03.17
    // instead of returns alerts for 2.01.17 ...
    intervals = _clearDuplicates(intervals);
    intervals.sort(compareIntervals);
    intervals = _mergeNotIntersectedIntervals(intervals);
    intervals = _clearDuplicates(intervals);

    storageData[key] = _extends({}, data, {
        intervals
    });

    return storageData;
};

/*
 * Do merge for not intersect intervals in real dates but intersected in marker dates
 * So we can simple join this intervals and get min/max marker dates
 * */
const _mergeNotIntersectedIntervals = (intervals, index = null) => {
    if (!intervals || !intervals.length || intervals.length < 2) {
        return intervals;
    }

    if (index === intervals.length - 1) {
        return intervals;
    }

    index = index || 0;
    const bigger = intervals[index];
    const smaller = intervals[index + 1];

    // (smallerDatesInterval, biggerDatesInterval)
    if (+smaller.minDate.dateMarker.dateRaw <= +bigger.minDate.dateMarker.dateRaw && +smaller.maxDate.dateMarker.dateRaw <= +bigger.maxDate.dateMarker.dateRaw && +smaller.maxDate.dateMarker.dateRaw >= +bigger.minDate.dateMarker.dateRaw) {

        const items = [...bigger.items, ...smaller.items];

        let mergedInterval = {
            minDate: _getMinDate(items, +smaller.minDate.dateMarker.dateRaw),
            maxDate: _getMaxDate(items, +bigger.maxDate.dateMarker.dateRaw),
            items
        };

        intervals = [...intervals.slice(index + 1)];
        intervals[index] = mergedInterval;

        return _mergeNotIntersectedIntervals(intervals, index);
    } else {
        return _mergeNotIntersectedIntervals(intervals, index + 1);
    }
};

/*
 * Add new interval with data (alerts) from db to storage.
 * Add or intersect with already existed intervals
 * */
const _addInterval = (leftIndex, rightIndex, intervals, newInterval) => {
    //region 1 check empty

    if (!newInterval) {
        return intervals;
    }

    if (!intervals || !intervals.length) {
        return [newInterval];
    }

    let leftInterval = intervals[leftIndex];
    let rightInterval = intervals[rightIndex];

    //endregion
    //region 2 check if already in intervals

    // already included in left
    if (+leftInterval.minDate.dateRaw <= +newInterval.minDate.dateRaw && +leftInterval.maxDate.dateRaw >= +newInterval.maxDate.dateRaw) {
        return intervals;
    }
    // already included in right
    if (+rightInterval.minDate.dateRaw <= +newInterval.minDate.dateRaw && +rightInterval.maxDate.dateRaw >= +newInterval.maxDate.dateRaw) {
        return intervals;
    }

    // if newInterval include current interval
    if (leftIndex === rightIndex) {
        if (+newInterval.minDate.dateRaw <= +leftInterval.minDate.dateRaw && +newInterval.maxDate.dateRaw >= +leftInterval.maxDate.dateRaw) {
            return [newInterval];
        }
    }

    //endregion
    //region 3 add at the start or at the end

    // add at the start
    if (+leftInterval.minDate.dateRaw > +newInterval.maxDate.dateRaw) {
        intervals = [newInterval, ...intervals];
        return intervals;
    }

    // add at the end
    if (+rightInterval.maxDate.dateRaw < +newInterval.minDate.dateRaw) {
        intervals = [...intervals, newInterval];
        return intervals;
    }

    //endregion
    //region 4 intersect left

    let mergedInterval = null;

    let leftArray = null,
        rightArray = null;

    if (leftIndex < rightIndex) {
        // all before left (all greater  > left)
        leftArray = leftIndex > 0 ? intervals.slice(0, leftIndex + 1) : [];

        // all after right (all smaller < right)
        rightArray = rightIndex === intervals.length - 1 ? [] : intervals.slice(rightIndex + 1);
    } else {
        leftArray = intervals;
        rightArray = [];
    }

    const _mergeWithLeft = mergedInterval => {
        intervals = [...leftArray, mergedInterval, ...intervals.slice(leftIndex + 1)];

        return intervals;
    };

    // (left, new)
    if (+leftInterval.minDate.dateRaw <= +newInterval.minDate.dateRaw && +leftInterval.maxDate.dateRaw <= +newInterval.maxDate.dateRaw && +leftInterval.maxDate.dateRaw >= +newInterval.minDate.dateRaw) {
        // intersect (new, right)

        // need merge: left, new, right
        if (+rightInterval.minDate.dateRaw <= +newInterval.maxDate.dateRaw) {
            mergedInterval = _mergeIntersectedIntervals(leftInterval, newInterval, rightInterval);
            intervals = [...leftArray, mergedInterval, ...rightArray];

            return intervals;
        }

        // need merge: left, new
        return _mergeWithLeft(_mergeIntersectedIntervals(leftInterval, newInterval));
    }

    // intersect left (new, left)
    if (+leftInterval.minDate.dateRaw >= +newInterval.minDate.dateRaw && +leftInterval.maxDate.dateRaw >= +newInterval.maxDate.dateRaw && +leftInterval.minDate.dateRaw <= +newInterval.maxDate.dateRaw) {
        return _mergeWithLeft(_mergeIntersectedIntervals(newInterval, leftInterval));
    }

    //endregion
    //region 5 intersect right

    const _mergeWithRight = mergedInterval => {
        intervals = [...intervals.slice(0, rightIndex), ...mergedInterval, ...rightArray];
        return intervals;
    };

    // intersect right (right, new)
    if (+rightInterval.minDate.dateRaw <= +newInterval.minDate.dateRaw && +rightInterval.maxDate.dateRaw <= +newInterval.maxDate.dateRaw && +rightInterval.maxDate.dateRaw >= +newInterval.minDate.dateRaw) {
        return _mergeWithRight(_mergeIntersectedIntervals(rightInterval, newInterval));
    }

    // intersect right (new, right)
    if (+rightInterval.minDate.dateRaw >= +newInterval.minDate.dateRaw && +rightInterval.maxDate.dateRaw >= +newInterval.maxDate.dateRaw && +rightInterval.minDate.dateRaw <= +newInterval.maxDate.dateRaw) {
        return _mergeWithRight(_mergeIntersectedIntervals(newInterval, rightInterval));
    }

    //endregion
    //region 6 found closest limits (example 3 and 4), then new interval exist between this limits

    if (leftIndex + 1 === rightIndex) {
        intervals = [...intervals.slice(0, leftIndex + 1), // include left
        newInterval, ...rightArray // include right
        ];
        return intervals;
    }

    //endregion
    //region 7 next recursion step divide by 2

    // before middle
    const middleIndex = parseInt((leftIndex + rightIndex) / 2);
    let middleInterval = intervals[middleIndex];
    if (+middleInterval.maxDate.dateRaw < +newInterval.minDate.dateRaw) {
        return _addInterval(leftIndex, middleIndex, intervals, newInterval);
    }

    return _addInterval(middleIndex, rightIndex, intervals, newInterval);

    //endregion
};

/*
 * firstInterval(dates) < secondInterval(dates) < thirdInterval(dates)
 * firstInterval intersect with secondInterval
 * secondInterval intersect with thirdInterval
 * First interval with greater dates then less and so on. Can be 2 or 3 intervals
 * 1 interval:
 *      01.01,
 *      02.01,
 *      03.01,
 *      08.01,
 *      09.01,
 *      10.01,
 * 2 interval:
 *      01.01,
 *      06.01,
 *      07.01,
 *      11.01,
 *      12.01,
 *      13.01,
 * result interval:
 *      01.01,
 *      02.01,
 *      03.01,
 *      06.01,
 *      07.01,
 *      08.01,
 *      09.01,
 *      11.01,
 *      12.01,
 *      13.01,
 */
const _mergeIntersectedIntervals = (firstInterval, secondInterval, thirdInterval) => {
    let mergedInterval = _mergeTwoIntersectedIntervals(0, firstInterval.items.length - 1, firstInterval, secondInterval);

    if (thirdInterval) {
        mergedInterval = _mergeTwoIntersectedIntervals(0, mergedInterval.items.length - 1, mergedInterval, thirdInterval);
    }

    return mergedInterval;
};

const _mergeTwoIntersectedIntervals = (leftIndex, rightIndex, rightInterval, leftInterval) => {
    const { items } = rightInterval;
    const leftItem = items[leftIndex];
    const rightItem = items[rightIndex];

    const maxLeftIntervalDateRaw = +leftInterval.maxDate.dateRaw;
    const minLeftIntervalDateRaw = +leftInterval.minDate.dateRaw;

    //found closest limits (example 3 and 4), then new interval exist after the left
    if (leftIndex + 1 === rightIndex) {

        // because of items sorted by date asc (left greater right)
        const minRightIntervalDateRaw = +rightItem.dateRaw;
        const maxRightIntervalDateRaw = +leftItem.dateRaw;

        // 0 => L + D => END
        // always must intersected
        if (minRightIntervalDateRaw <= minLeftIntervalDateRaw && minLeftIntervalDateRaw <= maxRightIntervalDateRaw) {
            const rightArr = rightInterval.items.slice(leftIndex + 1);
            const items = [...leftInterval.items, ...rightArr];

            let mergedInterval = {
                minDate: _getMinDate(items, +rightInterval.minDate.dateMarker.dateRaw),
                maxDate: _getMaxDate(items, +leftInterval.maxDate.dateMarker.dateRaw),
                items
            };

            return mergedInterval;
        }

        throw 'INTERVALS SHOULD BE INTERSECTED';
    }

    const middleIndex = parseInt((leftIndex + rightIndex) / 2);
    const middleItem = items[middleIndex];
    const middleDateRaw = +middleItem.dateRaw;
    // items sorted by date asc 11.01, 10.01 ... 01.01
    // if date less then search bigger date (go to left )
    // if date greater then search less date (go to right)
    if (middleDateRaw < minLeftIntervalDateRaw) {
        return _mergeTwoIntersectedIntervals(leftIndex, middleIndex, rightInterval, leftInterval);
    }

    return _mergeTwoIntersectedIntervals(middleIndex, rightIndex, rightInterval, leftInterval);
};

//endregion
//region get from storage

export const getFromStorage = (storageDate, date, showImportant = false, count = ALERTS_PER_DIRECTION) => {
    const key = showImportant ? GLOBAL_TYPES.ALERTS_IMPORTANT : GLOBAL_TYPES.ALERTS;

    const data = storageDate[key];
    if (!data) {
        throw 'ERROR during get alerts data from storage';
    }

    const dateRaw = dateToTst(date);
    const empty = {
        prev: [],
        next: []
    };
    const { intervals } = data;
    if (!intervals || !intervals.length) {
        return empty;
    }

    let interval = _findIntervalByDate(0, intervals.length - 1, intervals, +dateRaw);
    if (!interval) {
        interval = intervals[intervals.length - 1];
    }

    if (!interval.items) {
        return empty;
    }

    const dateIndex = _findIntersectedItemIndexInInterval(0, interval.items.length - 1, interval, +dateRaw);
    return _getPagingFromInterval(interval, dateIndex, count);
};

/*
 * Find interval by selected date from client
 * */
const _findIntervalByDate = (leftIndex, rightIndex, intervals, dateRaw) => {
    if (!intervals || !intervals.length) {
        return null;
    }

    const leftInterval = intervals[leftIndex];
    const rightInterval = intervals[rightIndex];

    if (leftIndex === rightIndex) {
        if (+leftInterval.minDate.dateMarker.dateRaw <= dateRaw && +leftInterval.maxDate.dateMarker.dateRaw >= dateRaw) {
            return leftInterval;
        }

        return null;
    }

    if (leftIndex + 1 === rightIndex) {
        // included in left
        if (+leftInterval.minDate.dateMarker.dateRaw <= dateRaw && +leftInterval.maxDate.dateMarker.dateRaw >= dateRaw) {
            return leftInterval;
        }
        // included in right
        if (+rightInterval.minDate.dateMarker.dateRaw <= dateRaw && +rightInterval.maxDate.dateMarker.dateRaw >= dateRaw) {
            return rightInterval;
        }

        return null;
    }

    const middleIndex = parseInt((leftIndex + rightIndex) / 2);
    const middleInterval = intervals[middleIndex];

    if (+middleInterval.minDate.dateMarker.dateRaw > dateRaw) {
        return _findIntervalByDate(middleIndex, rightIndex, intervals, dateRaw);
    }

    if (+middleInterval.maxDate.dateMarker.dateRaw < dateRaw) {
        return _findIntervalByDate(leftIndex, middleIndex, intervals, dateRaw);
    }

    return middleInterval;
};

/*
 * Find neighbours items (the closest to selected date)
 * */
const _findIntersectedItemIndexInInterval = (leftIndex, rightIndex, interval, dateRaw) => {
    const { items } = interval;
    const leftItem = items[leftIndex];
    const rightItem = items[rightIndex];

    // check if date out of interval (dateMarker example)
    if (leftIndex === 0 && rightIndex === items.length - 1) {
        if (+leftItem.dateRaw <= dateRaw) {
            return leftIndex; // left dot have +1 because when cut array we dont take last item in slice - so left item will not take, but right will take so we should cut it 
        }

        if (+rightItem.dateRaw >= dateRaw) {
            return rightIndex + 1;
        }
    }

    // if 0 then no items from cache (situation when 1 item)
    if (leftIndex === rightIndex && leftIndex === 0) {
        return null;
    }

    if (leftIndex + 1 === rightIndex) {
        if (+leftItem.dateRaw >= dateRaw && dateRaw >= +rightItem.dateRaw) {
            if (+rightItem.dateRaw == dateRaw) {
                return rightIndex + 1;
            }

            return leftIndex;
        }

        throw 'ERROR IN FIND ITEM IN INTERVAL BY SELECTED DATE. SHOULD NOT FIRED!';
    }

    const middleIndex = parseInt((leftIndex + rightIndex) / 2);
    const middleItem = items[middleIndex];
    const middleDateRaw = +middleItem.dateRaw;
    // items sorted by date asc 11.01, 10.01 ... 01.01
    // if date less then search bigger date (go to left )
    // if date greater then search less date (go to right)
    if (middleDateRaw < dateRaw) {
        return _findIntersectedItemIndexInInterval(leftIndex, middleIndex, interval, dateRaw);
    }

    return _findIntersectedItemIndexInInterval(middleIndex, rightIndex, interval, dateRaw);
};

/*
 * Get only needed count from storage (for prev and next directions)
 * */
const _getPagingFromInterval = (interval, index, count) => {
    let prev = interval.items.slice(0, index);
    let next = interval.items.slice(index);

    if (prev.length > count) {
        prev = prev.slice(-count);
    }

    if (next.length > count) {
        next = next.slice(0, count);
    }

    return {
        prev,
        next
    };
};

//endregion
//region redux state merging

export const mergeStateDateGroupedItems = (oldDateGroupedItemsState, newItems) => {
    let resultDateGroupedItems = [];
    const oldDateGroupedItems = [...oldDateGroupedItemsState];
    if (!newItems || !newItems.length) {
        return oldDateGroupedItems;
    }

    const { dateGroupedItems: newDateGroupedItems } = processItems(newItems);

    // Do merge state grouped by date and title items with new results items
    for (let j = 0; j < newDateGroupedItems.length; j++) {
        const newDateGroupedItem = newDateGroupedItems[j];
        let oldDateGroupedItemsFiltered = oldDateGroupedItems.filter(d => d.dateGroup === newDateGroupedItem.dateGroup);

        // new date
        if (!oldDateGroupedItemsFiltered.length) {
            resultDateGroupedItems.push(newDateGroupedItem);
            continue;
        }

        let oldDateGroupedItem = oldDateGroupedItemsFiltered[0];
        // delete current date group from state because it will add in new result
        // need to leave only what don't process in this block
        let index = oldDateGroupedItems.findIndex(d => d.dateGroup === oldDateGroupedItem.dateGroup);

        oldDateGroupedItems.splice(index, 1);

        let resultGroupedItems = [];

        for (let i = 0; i < newDateGroupedItem.groupedItems.length; i++) {
            const newGroupedItem = newDateGroupedItem.groupedItems[i];
            let oldGroupedItemsFiltered = oldDateGroupedItem.groupedItems.filter(d => d.title === newGroupedItem.title);

            // new title
            if (!oldGroupedItemsFiltered.length) {
                resultGroupedItems.push(newGroupedItem);
                continue;
            }

            let oldGroupedItem = oldGroupedItemsFiltered[0];

            // delete current date group from state because it will add in new result
            // need to leave only what don't process in this block
            let index = oldDateGroupedItem.groupedItems.findIndex(d => d.title === oldGroupedItem.title);
            oldDateGroupedItem.groupedItems.splice(index, 1);

            const allItems = mergeNewItemsToState(newGroupedItem.items, oldGroupedItem.items);
            oldGroupedItem.items = allItems;
            oldGroupedItem.items.sort(compareAlertsDesc);
            resultGroupedItems.push(oldGroupedItem);
        }

        const mergedGroupedItemsResult = [...resultGroupedItems, ...oldDateGroupedItem.groupedItems];

        mergedGroupedItemsResult.sort(compareGroupedItemByTitle);
        oldDateGroupedItem.groupedItems = mergedGroupedItemsResult;
        resultDateGroupedItems.push(oldDateGroupedItem);
    }

    const mergedDateGroupedItemsResult = [...resultDateGroupedItems, ...oldDateGroupedItems];

    return mergedDateGroupedItemsResult;
};

/*
 * sourceArray - new
 * targetArray - old
 * */
export const mergeNewItemsToState = (sourceArray, targetArray) => {
    if (!targetArray || !targetArray.length) {
        return sourceArray;
    }

    if (!sourceArray || !sourceArray.length) {
        return targetArray;
    }

    const leftTargetDateRaw = +targetArray[0].dateRaw;
    const rightTargetDateRaw = +targetArray[targetArray.length - 1].dateRaw;

    let leftSourceDateRaw = +sourceArray[0].dateRaw;
    let rightSourceDateRaw = +sourceArray[sourceArray.length - 1].dateRaw;

    // source in target
    if (leftTargetDateRaw >= leftSourceDateRaw && rightTargetDateRaw <= rightSourceDateRaw) {
        return targetArray;
    }

    // target in source
    if (leftSourceDateRaw >= leftTargetDateRaw && rightSourceDateRaw <= rightTargetDateRaw) {
        return sourceArray;
    }

    // source, target
    if (rightSourceDateRaw <= leftTargetDateRaw) {
        if (rightSourceDateRaw === leftTargetDateRaw) {
            return [...sourceArray.slice(0, sourceArray.length - 1), ...targetArray];
        }

        return [...sourceArray, ...targetArray];
    }

    // target, source
    if (rightTargetDateRaw <= leftSourceDateRaw) {
        if (rightTargetDateRaw === leftSourceDateRaw) {
            return [...targetArray.slice(0, targetArray.length - 1), ...sourceArray];
        }
        return [...targetArray, ...sourceArray];
    }

    // source <= target (intersected)
    if (leftSourceDateRaw <= leftTargetDateRaw && rightSourceDateRaw >= leftTargetDateRaw) {
        return _mergeTwoArrays(0, sourceArray.length - 1, sourceArray, targetArray);
    }

    // source >= target (intersected)
    if (leftTargetDateRaw <= leftSourceDateRaw && rightTargetDateRaw >= leftSourceDateRaw) {
        return _mergeTwoArrays(0, targetArray.length - 1, targetArray, sourceArray);
    }

    throw 'ERROR DURING MERGE 2 ARRAYS. CAN NOT BE CALLING THIS';
};

export const _mergeTwoArrays = (leftIndex, rightIndex, sourceArray, targetArray) => {
    const leftTargetDateRaw = +targetArray[0].dateRaw;
    const rightTargetDateRaw = +targetArray[targetArray.length - 1].dateRaw;

    let leftSourceDateRaw = +sourceArray[leftIndex].dateRaw;
    let rightSourceDateRaw = +sourceArray[rightIndex].dateRaw;

    if (leftIndex + 1 === rightIndex) {
        const intersectIndex = rightSourceDateRaw > leftTargetDateRaw ? leftIndex : rightIndex;

        return [...sourceArray.slice(0, intersectIndex + 1), ...targetArray];
    }

    const middleIndex = parseInt((leftIndex + rightIndex) / 2);
    const middleDateRaw = +sourceArray[middleIndex].dateRaw;
    if (middleDateRaw < leftTargetDateRaw) {
        return _mergeTwoArrays(leftIndex, middleIndex, sourceArray, targetArray);
    }

    return _mergeTwoArrays(middleIndex, rightIndex, sourceArray, targetArray);
};

//endregion
//region helpers

/*
 * Create dates for items, where dateMarker can be out of
 * items date. You can select for example 1.1.2017 but get
 * last items only start from 1.11.2016 that means that
 * dateMarker will be 1.1.2017. But it can not be greater
 * then today
 * */
export const _getMaxDate = (items, dateRaw) => {
    if (!items || !items.length) {
        return null;
    }

    const itemMaxDate = items[0];
    if (!itemMaxDate) {
        return null;
    }

    let maxDateRaw = dateRaw > +itemMaxDate.dateRaw ? dateRaw : +itemMaxDate.dateRaw;

    // maxDate can not be greater then today - because in future can be new
    // alerts and we should send request for get they are
    const dateTodayRaw = dateToTst(new Date());
    maxDateRaw = dateTodayRaw < maxDateRaw ? dateTodayRaw : maxDateRaw;

    return {
        dateMarker: {
            date: tstToDate(maxDateRaw),
            dateRaw: maxDateRaw
        },
        date: tstToDate(itemMaxDate.dateRaw),
        dateRaw: itemMaxDate.dateRaw.toString()
    };
};

export const _getMinDate = (items, dateRaw) => {
    if (!items || !items.length) {
        return null;
    }

    const itemMinDate = items[items.length - 1];
    if (!itemMinDate) {
        return null;
    }

    const minDateRaw = dateRaw < +itemMinDate.dateRaw ? dateRaw : +itemMinDate.dateRaw;

    return {
        dateMarker: {
            date: tstToDate(minDateRaw),
            dateRaw: minDateRaw
        },
        date: tstToDate(itemMinDate.dateRaw),
        dateRaw: itemMinDate.dateRaw.toString()
    };
};

export const compareIntervals = (a, b) => {
    if (+a.maxDate.dateMarker.dateRaw > +b.maxDate.dateMarker.dateRaw) return -1;
    if (+a.maxDate.dateMarker.dateRaw < +b.maxDate.dateMarker.dateRaw) return 1;

    return 0;
};

/*
 * While will be no stable version of cache (FE + BE) will be use this func
 * Now exist bug in BE
 * */
const _clearDuplicates = intervals => {
    if (!intervals || !intervals.length) {
        return intervals;
    }

    const newIntervals = [];
    intervals.forEach(interval => {
        if (interval.items && interval.items.length) {
            const items = interval.items;
            const unickItems = {};
            items.forEach(item => {
                unickItems[item.dateRaw + item.title] = item;
            });

            const newItems = [];
            const keys = Object.keys(unickItems);
            keys.forEach(key => {
                newItems.push(unickItems[key]);
            });

            newItems.sort(compareAlerts);
            interval.items = newItems;
            newIntervals.push(interval);
        }
    });

    return newIntervals;
};

//endregion


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/alerts/alerts.algorithms.js